// components/FeaturesSection.jsx
import React from 'react';

const FeaturesSection = () => {
    const features = [
        { icon: '↗', color: 'blue', title: 'Send Money', desc: 'Send money to anyone instantly using UPI.' },
        { icon: '⌗', color: 'green', title: 'Scan & Pay', desc: 'Scan any QR code and pay in just seconds.' },
        { icon: '▤', color: 'purple', title: 'Pay Bills', desc: 'Pay electricity, water, gas and broadband bills.' },
        { icon: '▣', color: 'orange', title: 'Mobile Recharge', desc: 'Recharge mobile, DTH and FASTag instantly.' },
        { icon: '★', color: 'pink', title: 'Rewards', desc: 'Earn exciting rewards on every transaction.' },
    ];

    return (
        <section className="features motion-section">
            <div className="container">
                <div className="section-title">
                    <h2>
                        Everything you need in
                        <span> one app</span>
                    </h2>
                    <div className="line"></div>
                </div>
                <div className="feature-grid">
                    {features.map((item, index) => (
                        <div className="feature-card" key={index}>
                            <div className={`icon ${item.color}`} aria-hidden="true">
                                {item.icon}
                            </div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;